import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

const COLUMNS = [
  {
    title: "Shop",
    span: "md:col-span-3",
    links: [
      { to: "/products", id: "products", label: "Products" },
      { to: "/products/CORE-500", id: "core500", label: "CORE 500" },
      { to: "/accessories", id: "accessories", label: "Accessories" },
      { to: "/cart", id: "cart", label: "Cart" },
    ],
  },
  {
    title: "Company",
    span: "md:col-span-2",
    links: [
      { to: "/about", id: "about", label: "About" },
      { to: "/videos", id: "videos", label: "Videos" },
      { to: "/production", id: "production", label: "Inside the Factory" },
      { to: "/reviews", id: "reviews", label: "Reviews" },
      { to: "/distributors", id: "distributors", label: "Distributors" },
    ],
  },
  {
    title: "Customer care",
    span: "md:col-span-2",
    links: [
      { to: "/delivery-policy", id: "delivery", label: "Delivery" },
      { to: "/warranty", id: "warranty", label: "Warranty" },
      { to: "/refund-policy", id: "refund", label: "Returns & refunds" },
      { to: "/contact", id: "contact", label: "Contact" },
    ],
  },
];

const LinkColumn = ({ col }) => (
  <div className={col.span}>
    <h4 className="eyebrow" style={{ color: "var(--brand)" }}>{col.title}</h4>
    <ul className="mt-5 space-y-3">
      {col.links.map((l) => (
        <li key={l.id}><Link to={l.to} data-testid={`footer-${l.id}`}>{l.label}</Link></li>
      ))}
    </ul>
  </div>
);

const ContactColumn = () => (
  <div className="md:col-span-2">
    <h4 className="eyebrow" style={{ color: "var(--brand)" }}>Contact</h4>
    <ul className="mt-5 space-y-3 text-sm" style={{ color: "#A1A1AA" }}>
      <li>
        <a data-testid="footer-whatsapp" href="https://wa.me/2347072260372" className="inline-flex items-center gap-1 hover:text-white">
          WhatsApp <ArrowUpRight size={14} />
        </a>
      </li>
      <li><a href="mailto:info@sunpresssolar.com">info@sunpresssolar.com</a></li>
      <li>19 Eru-Ifa Street, Lekki, Lagos</li>
    </ul>
  </div>
);

const LegalBar = () => (
  <div className="border-t" style={{ borderColor: "#27272A" }}>
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-wrap justify-between gap-4 text-xs" style={{ color: "#71717A" }}>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        <span>© {new Date().getFullYear()} SunPress Solar. Bandoh Prime Global Ltd.</span>
        <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-white">Privacy</Link>
        <Link to="/terms" data-testid="footer-terms" className="hover:text-white">Terms</Link>
      </div>
      <span><Link to="/admin/login" data-testid="footer-admin-login">Admin</Link></span>
    </div>
  </div>
);

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="mt-32" style={{ background: "#0A0A0A", color: "#F9F6F0" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo variant="light" size={64} />
          <p className="mt-6 max-w-md" style={{ color: "#A1A1AA" }}>
            Low-watt appliances engineered for solar and inverter homes across West Africa.
            Press on. The power stays on.
          </p>
        </div>
        {COLUMNS.map((col) => <LinkColumn key={col.title} col={col} />)}
        <ContactColumn />
      </div>
      <LegalBar />
    </footer>
  );
}
